if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) {
      this.enableArQrFallbacks();
      return;
    }

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
    window.requestAnimationFrame(() => this.syncArQrFallbacks());
  },

  syncArQrFallbacks() {
    document.querySelectorAll('[data-rfa-ar-qr-trigger]').forEach((button) => {
      const isNativeArAvailable = !button.hasAttribute('data-shopify-xr-hidden');

      if (isNativeArAvailable) {
        button.classList.remove('rfa-ar-qr-fallback');
        button.rfaArQrHandler && button.removeEventListener('click', button.rfaArQrHandler, true);
        delete button.rfaArQrHandler;
        delete button.dataset.rfaArQrBound;
        return;
      }

      this.enableArQrFallback(button);
    });
  },

  enableArQrFallback(button) {
      if (button.dataset.rfaArQrBound === 'true') return;

      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      button.dataset.rfaArQrBound = 'true';
      button.classList.add('rfa-ar-qr-fallback');
      button.rfaArQrHandler = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isExpanded));
        panel.setAttribute('aria-hidden', String(isExpanded));

        if (isExpanded) {
          panel.classList.remove('is-open');
          panel.hidden = true;
        } else {
          panel.hidden = false;
          this.renderArQrCode(panel);
          window.requestAnimationFrame(() => panel.classList.add('is-open'));
        }
      };
      button.addEventListener('click', button.rfaArQrHandler, true);
  },

  renderArQrCode(panel) {
    const qrCode = panel.querySelector('[data-rfa-ar-qr-code]');
    if (!qrCode || qrCode.dataset.rfaArQrRendered === 'true' || !window.QRCode) return;

    const qrCodeBackground = window.getComputedStyle(qrCode).backgroundColor;

    new window.QRCode(qrCode, {
      text: qrCode.dataset.rfaArQrUrl,
      width: 180,
      height: 180,
      colorDark: '#000000',
      colorLight: qrCodeBackground,
      correctLevel: window.QRCode.CorrectLevel.M,
    });
    qrCode.dataset.rfaArQrRendered = 'true';
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (!window.ProductModel) return;

  window.ProductModel.syncArQrFallbacks();
  window.ProductModel.loadShopifyXR();
});
